export class Entrevistas {
  constructor (
    public count: number,
    public result: Entrevista[]
  ) {}
}

export class Entrevista {
  constructor(
    public id : string,
    public lang? : string,
    public title? : string,
    public abstract? : string,
    public date? : string,
    public informant?: Informant[],
    public image?: ImageDedalo[],
    public audiovisual?: Audiovisual[],
  ) {}
}

export class Informant {
  constructor(
    public id: string,
    public name: string,
    public surname: string
  ) {}
}

export class ImageDedalo {
  constructor(
    public id: string,
    public src: string
  ){}
}

export class Audiovisual {
  constructor(
    public id: string,
    public video: string,
    public rsc36: string
  ){}
}
